import { style } from "@vanilla-extract/css";

import { vars } from "~/styles/tokens.css";

// Top-of-page header block. Title + optional subtitle stack on the
// left, actions slot on the right. Matches the prototype's
// pageTitle/pageSubtitle pattern.
export const header = style({
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  gap: vars.space.md,

  marginBottom: vars.space.lg,
});

export const titleBlock = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.xs,
  minWidth: 0,
});

// Title uses heading font via the global h1 rule, sized at 2xl (24px)
// to match the prototype's page-title treatment. The global h1 default
// (4xl / 36px) is reserved for display/landing usage.
export const title = style({
  fontSize: vars.fontSize["2xl"],
  color: vars.color.primary,
  margin: 0,
  lineHeight: vars.lineHeight.tight,
});

export const subtitle = style({
  fontSize: vars.fontSize.sm,
  color: vars.color.textMuted,
  lineHeight: vars.lineHeight.normal,
  margin: 0,
});

export const actions = style({
  display: "flex",
  gap: vars.space.sm,
  alignItems: "center",
  flexShrink: 0,
});
